import { useEffect } from 'react';
import BlogHeader from '../components/BlogHeader';
import NewsletterSignup from '../components/NewsletterSignup';
import Footer from '../../home/components/Footer';
import ArticleHero from './components/ArticleHero';
import IntroSection from './components/IntroSection';
import ReasonsPartOne from './components/ReasonsPartOne';
import ReasonsPartTwo from './components/ReasonsPartTwo';
import ComparisonSection from './components/ComparisonSection';
import GettingStartedSection from './components/GettingStartedSection';
import ConclusionSection from './components/ConclusionSection';

export default function MonthlyBookkeepingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const articleStructuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Why El Paso Small Businesses Need Monthly Bookkeeping",
    "description": "Discover seven compelling reasons why El Paso TX small businesses need monthly bookkeeping to protect profits, stay tax-ready, and make smarter growth decisions.",
    "author": { "@type": "Organization", "name": "El Paso QuickBooks Bookkeeping Services" },
    "publisher": { "@type": "Organization", "name": "El Paso QuickBooks Bookkeeping Services" },
    "datePublished": "2025-02-18",
    "dateModified": new Date().toISOString().split("T")[0],
    "keywords": "Why El Paso Small Businesses Need Monthly Bookkeeping, El Paso TX, monthly bookkeeping, QuickBooks bookkeeping service, El Paso bookkeepers",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://elpasoquickbooksbookkeeping.com/blog/why-el-paso-small-businesses-need-monthly-bookkeeping"
    }
  };

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Why do El Paso small businesses need monthly bookkeeping instead of annual?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Monthly bookkeeping gives El Paso TX business owners real-time cash-flow visibility, catches errors within 30 days instead of 12 months, keeps financial statements loan-ready at all times, and typically saves $1,200 to $3,000 per year in tax-preparation fees compared to annual catch-up bookkeeping."
        }
      },
      {
        "@type": "Question",
        "name": "How much does monthly bookkeeping cost for a small business in El Paso TX?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Professional monthly bookkeeping services in El Paso TX typically range from $200 to $600 per month depending on transaction volume, number of accounts, and whether payroll is included. This investment is significantly less than the cost of fixing a year of accumulated errors, which averages $5,000 or more."
        }
      },
      {
        "@type": "Question",
        "name": "What are the signs that my El Paso business needs professional monthly bookkeeping?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Key indicators include monthly revenue exceeding $10,000, having employees on payroll, collecting and remitting sales tax, falling behind on bank reconciliation, planning to apply for a loan, or dreading tax season every year. If any of these apply, professional monthly bookkeeping will almost certainly save you money."
        }
      },
      {
        "@type": "Question",
        "name": "What reports should I review every month as an El Paso business owner?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The three essential monthly reports are your profit-and-loss statement (shows revenue minus expenses), your balance sheet (shows assets, liabilities, and equity), and your cash-flow statement (shows money moving in and out). Together, these reports give you a complete picture of your business financial health."
        }
      }
    ]
  };

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://elpasoquickbooksbookkeeping.com/" },
      { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://elpasoquickbooksbookkeeping.com/blog" },
      { "@type": "ListItem", "position": 3, "name": "Monthly Bookkeeping", "item": "https://elpasoquickbooksbookkeeping.com/blog/why-el-paso-small-businesses-need-monthly-bookkeeping" }
    ]
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <BlogHeader />
      <ArticleHero />

      <main>
        <article className="max-w-4xl mx-auto px-6 pb-16">
          <IntroSection />
          <ReasonsPartOne />
          <ReasonsPartTwo />
          <ComparisonSection />
          <GettingStartedSection />
          <ConclusionSection />
        </article>
      </main>

      <NewsletterSignup />
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </div>
  );
}
